import gql from "graphql-tag";

export const contentTopicsQuery = gql`
    query getContentTopicsQuery(
        $universitySlug: String
        $universityId: String
        $hideEmpty: Boolean
        $idIn: [String]
    ) {
        blogTopics(
            universitySlug: $universitySlug
            universityId: $universityId
            hideEmpty: $hideEmpty
            idIn: $idIn
        ) {
            id
            name
        }
    }
`;
